import { Moon, Sun } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { useTheme } from "@/components/theme-provider";

interface ThemeToggleProps {
  showLabel?: boolean;
}

export function ThemeToggle({ showLabel = false }: ThemeToggleProps) {
  const { theme, setTheme } = useTheme();

  return (
    <div className="flex flex-col gap-2">
      {showLabel && <span className="text-sm font-medium">Switch Theme</span>}
      <div className="flex items-center space-x-2">
        <Sun className="h-[1.2rem] w-[1.2rem] text-amber-500" />
        <Switch
          checked={theme === "dark"}
          onCheckedChange={() => setTheme(theme === "dark" ? "light" : "dark")}
          aria-label="Toggle theme"
          className="data-[state=checked]:bg-indigo-600"
        />
        <Moon className="h-[1.2rem] w-[1.2rem] text-indigo-600" />
      </div>
    </div>
  );
}
